import DrawerController from "./drawer_controller";

/**
 * Leave Request Drawer Controller
 *
 * This controller extends the base Drawer Controller to add functionality
 * specific to leave request drawers, such as loading content from a URL.
 */
export default class extends DrawerController {
  static targets = [...DrawerController.targets, "drawerContent"];
  
  static values = {
    ...DrawerController.values
  };

  connect() {
    super.connect();
    console.log("LeaveRequestDrawerController connected");
  }

  /**
   * Override the open method to load content from URL
   */
  open(event) {
    // Store the clicked element before calling super.open()
    this.clickedElement = event.currentTarget;
    console.log("Open clicked on:", this.clickedElement);
    
    // Call the parent open method to handle the drawer animation
    super.open(event);
    
    // Get the content URL from the clicked element
    const contentUrl = this.clickedElement.getAttribute("data-drawer-content-url") || 
                      this.clickedElement.getAttribute("data-drawer_content_url") || 
                      this.clickedElement.dataset.drawerContentUrl;
    
    console.log("Content URL:", contentUrl);
    
    // Load content if URL is specified
    if (contentUrl) {
      this.loadContent(contentUrl);
    }
  }

  /**
   * Load content into the drawer from the specified URL
   * @param {string} url - The URL to fetch content from
   */
  loadContent(url) {
    if (!url) return;
    
    // Get the drawer content element
    const drawerContentElement = this.contentTarget;
    if (!drawerContentElement) {
      console.error("Drawer content element not found");
      return;
    }
    
    // Show loading indicator
    drawerContentElement.innerHTML = '<div class="flex justify-center items-center py-12"><svg class="animate-spin h-8 w-8 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg></div>';
    
    console.log("Fetching content from:", url);
    
    // Fetch content
    fetch(url, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/html"
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then(html => {
      console.log("Content loaded successfully");
      drawerContentElement.innerHTML = html;
    })
    .catch(error => {
      console.error("Error loading drawer content:", error);
      drawerContentElement.innerHTML = `<div class="text-red-500 p-4">Error loading content: ${error.message}</div>`;
    });
  }
}
